import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventsNewVersionService {

  public_id = ''

  constructor() { }
}
